import { LessonDefinition } from "../../types";

const lesson: LessonDefinition = {
  id: "editor-essentials",
  courseId: "writing-and-editing",
  order: 1,
  title: "Editor essentials",
  summary:
    "The narrative editor is a word processor with the report tools in a panel on the right. This lesson covers the toolbar, the tabs, and when your work is saved.",
  learn: [
    "Use the formatting toolbar and the Narrative / Transcription tabs",
    "Know what the four right-panel tabs are for",
    "Understand when the editor saves",
  ],
  sceneId: "editor-essentials",
  tourId: "editor-essentials",
  minutes: 3,
  releasedAt: "2025-06-01T00:00:00.000Z",
  body: [
    {
      type: "paragraph",
      text: "Open any case from **Cases** and you are in the editor. Your narrative is on the left with a toolbar above it, and the AI tools are in the panel on the right.",
    },
    { type: "heading", text: "The toolbar" },
    {
      type: "bullets",
      items: [
        "Formatting: the Styles dropdown (Paragraph, Heading 1-3), Bold, Italic, Underline, Strikethrough, Text Color, Highlight color, Blockquote, Horizontal line, Bullet list, Ordered list, Undo, and Redo.",
        "**Find** and **Find and Replace** for the text.",
        "**Writing suggestions: on/off** for inline proofreading, and **Transcribe Audio** for dictating at the cursor.",
        "A category tag and a favorite star for organizing the case, and **Export** at the end.",
      ],
    },
    { type: "heading", text: "Tabs and panels" },
    {
      type: "steps",
      items: [
        "Click **Narrative** or **Transcription** above the text to switch views. A **Footage** tab appears when the case has analyzed video.",
        "In the right panel, click **Suggestions** for the score and gaps, **Snippets** for boilerplate, **Statutes** for charges, or **Redactions** for PII. A **Checklist** tab appears when the case started from a checklist.",
        "Select any text in the narrative to open the floating menu with **Enhance Writing**, **Redact**, and **Unredact**.",
      ],
    },
    {
      type: "callout",
      tone: "warning",
      title: "Saving",
      text: "The editor autosaves as you type, but only while it has focus. If you dictate or paste while another window is active, click into the narrative once so the save fires before you close the tab.",
    },
    {
      type: "paragraph",
      text: "Users with the Records role can open every case in the agency but cannot edit other officers' narratives. They can always export.",
    },
  ],
  related: ["review-the-draft", "polish-the-draft", "export-your-report"],
};

export default lesson;
